require('./cookies-enabler');

module.exports = window.COOKIES_ENABLER;
